module.exports = __webpack_public_path__ + "img/t4gclp.5be9df7c.svg";